import React from 'react';
import Image from '../../../components/AppImage';
import { Phone, Mail, Instagram, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom'; // <--- Das ist der einzige zusätzliche Import!

const Footer = ({ language }) => {
  const content = {
    de: {
      description: "Premium Barbershop in Bochum für moderne Schnitte, Bartstyling und klassische Rasuren.",
      quickLinks: "Quick Links",
      contact: "Kontakt",
      legal: "Rechtliches",
      copyright: "Alle Rechte vorbehalten.",
      privacy: "Datenschutz",
      imprint: "Impressum"
    },
    en: {
      description: "Premium barbershop in Bochum for modern cuts, beard styling and classic shaves.",
      quickLinks: "Quick Links",
      contact: "Contact",
      legal: "Legal",
      copyright: "All rights reserved.",
      privacy: "Privacy",
      imprint: "Imprint"
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary border-t border-secondary/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <Image
                src="/assets/images/e75f4f8f-2e2c-47d5-8be6-070fec062583-1755963588204.jpeg"
                alt="RWAN CUT Logo"
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <h3 className="font-heading font-bold text-xl text-secondary">RWAN CUT</h3>
                <p className="font-caption text-xs text-white/60">Premium Barbershop</p>
              </div>
            </div>
            <p className="font-body text-white/80 text-sm mb-4 leading-relaxed">
              {content?.[language]?.description}
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://instagram.com/rwan.cut" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-secondary/20 rounded-lg flex items-center justify-center hover:bg-secondary/30 transition-luxury group"
              >
                <Instagram size={18} className="text-secondary group-hover:scale-110 transition-luxury" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body font-semibold text-lg text-white mb-4">
              {content?.[language]?.quickLinks}
            </h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('#home')} 
                  className="font-body text-white/80 hover:text-secondary transition-luxury text-left"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('#services')} 
                  className="font-body text-white/80 hover:text-secondary transition-luxury text-left"
                >
                  Services & Preise
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('#hours')} 
                  className="font-body text-white/80 hover:text-secondary transition-luxury text-left"
                >
                  {language === 'de' ? 'Öffnungszeiten' : 'Opening Hours'}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('#location')} 
                  className="font-body text-white/80 hover:text-secondary transition-luxury text-left"
                >
                  {language === 'de' ? 'Standort' : 'Location'}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('#contact')} 
                  className="font-body text-white/80 hover:text-secondary transition-luxury text-left"
                >
                  {language === 'de' ? 'Kontakt' : 'Contact'}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-body font-semibold text-lg text-white mb-4">
              {content?.[language]?.contact}
            </h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-secondary" />
                <a href="tel:+491726060056" className="font-body text-white/80 hover:text-secondary text-sm transition-luxury">
                  +49 172 6060056
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-secondary" />
                <a href="mailto:rwanmaamo@gmail.com" className="font-body text-white/80 hover:text-secondary text-sm transition-luxury">
                  rwanmaamo@gmail.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Instagram size={16} className="text-secondary" />
                <a href="https://instagram.com/rwan.cut" target="_blank" rel="noopener noreferrer" className="font-body text-white/80 hover:text-secondary text-sm transition-luxury">
                  @rwan.cut
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin size={16} className="text-secondary mt-0.5 flex-shrink-0" />
                <span className="font-body text-white/80 text-sm">
                  Hellweg 15<br />
                  44787 Bochum, Germany
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-secondary/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="font-caption text-white/60 text-sm">
            © {new Date()?.getFullYear()} RWAN CUT. {content?.[language]?.copyright}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link
              to="/datenschutz"
              className="font-caption text-white/60 hover:text-secondary text-sm transition-luxury"
            >
              {content?.[language]?.privacy}
            </Link>
            <Link
              to="/impressum"
              className="font-caption text-white/60 hover:text-secondary text-sm transition-luxury"
            >
              {content?.[language]?.imprint}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;